import { useTranslation } from "react-i18next";
import { useCustomer } from "@/app/providers";
import { CustomerRepository } from "@/services/firebase/customer-repository";

export const useTranslations = () => {
  const { t, i18n } = useTranslation();
  const { customerId } = useCustomer();

  const changeLanguage = async (lang: string) => {
    try {
      await i18n.changeLanguage(lang);
      // Stocke la préférence de langue dans le localStorage
      localStorage.setItem("i18nextLng", lang);

      // Si l'utilisateur est connecté, sauvegarde sa langue préférée dans Firestore
      if (customerId) {
        try {
          await CustomerRepository.update(customerId, {
            preferredLanguage: lang,
          });
          console.log(`✅ Langue préférée sauvegardée: ${lang} pour le customer ${customerId}`);
        } catch (error) {
          console.error("❌ Erreur lors de la sauvegarde de la langue préférée:", error);
          // Ne pas bloquer le changement de langue même si la sauvegarde échoue
        }
      }

      return true;
    } catch (_error) {
      console.error("Error changing language:", _error);
      return false;
    }
  };

  const getCurrentLanguage = () => i18n.language;

  const getLanguages = () => [
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "es", name: "Español", flag: "🇪🇸" },
  ];

  return {
    t, // Fonction de traduction
    i18n, // Instance i18next
    changeLanguage, // Fonction pour changer de langue
    getCurrentLanguage, // Obtenir la langue actuelle
    getLanguages, // Liste des langues disponibles
  };
};
